<template>
  <div class="employees">
    <div class="employees-toolbar">
      <!-- page title -->
      <label class="h4 font-weight-bolder mr-5">Employees</label>
      <!-- toolbar -->
      <b-form-select class="employees-toolbar-sortby mr-1" v-model="sortby" :options="options" />
      <b-input-group class="employees-toolbar-search mr-4" prepend="search">
        <b-form-input v-model="search"></b-form-input>
      </b-input-group>
      <b-button v-b-modal.add-employee-modal variant="primary">Add Employee</b-button>
    </div>
    <!-- default email -->
    <div class="employees-default-email border-top p-4 d-flex flex-row align-items-center">
      <!-- labels -->
      <p class="font-weight-bold m-0 mr-1">Default Email:</p>
      <p v-show="!editingDefaultEmail" class="font-italic m-0">{{defaultEmail}}</p>
      <!-- email input -->
      <b-form-input
        v-show="editingDefaultEmail"
        v-model="defaultEmailInput"
        class="mx-2"
        style="width:25em"
      ></b-form-input>
      <!-- edit button -->
      <b-button
        size="sm"
        v-show="!editingDefaultEmail"
        variant="outline"
        @click="editingDefaultEmail = true"
      >
        <i class="material-icons">edit</i>
      </b-button>
      <!-- save button -->
      <b-button
        size="sm"
        v-show="editingDefaultEmail"
        variant="success"
        @click="editingDefaultEmail = false; updateDefaultEmail()"
      >Save</b-button>
    </div>
    <!-- card list -->
    <div class="employees-list">
      <employee-card v-for="(e,i) in employees" :key="i+e.name" :email="e.email"></employee-card>
    </div>

    <!-- add employee entry -->
    <b-modal id="add-employee-modal" title="Add Employee" @ok="addEmployeeSubmit">
      <!-- name -->
      <label for="add-employee-modal-name">Enter Name:</label>
      <b-form-input id="add-employee-modal-name" v-model="addEmployeeForm.name" placeholder="Name"></b-form-input>
      <!-- email -->
      <label for="add-employee-modal-email" class="pt-3">Enter Email:</label>
      <b-form-input
        id="add-employee-modal-email"
        v-model="addEmployeeForm.email"
        placeholder="Email"
      ></b-form-input>
    </b-modal>
  </div>
</template>

<script>
import EmployeeCard from "@/components/EmployeeCard";
export default {
  components: { EmployeeCard },
  data() {
    return {
      editingDefaultEmail: false,
      defaultEmailInput: "",
      selected: "cards",
      sortby: "email",
      search: "",
      addEmployeeForm: {
        name: "",
        email: ""
      },
      options: [
        { text: "Name", value: "name" },
        { text: "Email", value: "email" }
      ]
    };
  },
  computed: {
    employees() {
      let sortby = this.$data.sortby;
      return this.$store.state.employees
        .sort((a, b) => {
          let aClean = a[sortby];
          let bClean = b[sortby];
          if (sortby == "name" || sortby == "email") {
            aClean = aClean.toUpperCase();
            bClean = bClean.toUpperCase();
          }

          if (aClean < bClean) return -1;
          else if (aClean > bClean) return 1;
          else return 0;
        })
        .filter(emp => {
          let filterQuery = String(emp[sortby]);
          return filterQuery
            .toUpperCase()
            .includes(this.$data.search.toUpperCase());
        });
    },
    defaultEmail() {
      return this.$store.state.configs.defaultEmail;
    }
  },
  methods: {
    addEmployeeSubmit() {
      this.$store.dispatch("addEmployee", {
        name: this.$data.addEmployeeForm.name,
        email: this.$data.addEmployeeForm.email
      });
    },
    updateDefaultEmail() {
      this.$store.dispatch("setDefaultEmail", this.$data.defaultEmailInput);
    }
  }
};
</script>

<style lang="scss" scoped>
.employees {
  height: 100%;
  width: 100%;
  display: flex;
  flex-flow: column nowrap;

  &-toolbar {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: flex-start;
    margin: 1.5em;
    &-sortby {
      width: 12em;
    }
    &-search {
      width: 21em;
    }
  }

  &-list {
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;

    overflow-y: auto;
  }

  &-list-card {
    margin: 0.5em;
  }
}
</style>
